module.exports = __webpack_public_path__ + "media/images/lavita_banner/banner__sidebar--de-0505c2dc87c493692653b1e3c3fc6082.jpg";